import { soundClipsEn } from './en'

export const soundClipsEnGb = {
  ...soundClipsEn,
} as const
